import React from 'react'
import authConfig from "../../config/authConfig";

export default class LogoutOrNotAuthorized extends React.Component {

    render() {
        return (
            <div>

                <div className={"container"} style={{display: "flex", justifyContent: "center", marginTop: "5rem"}}>
                    <p style={{
                        fontSize: "20px",
                        textAlign: "center"
                    }}>
                        <strong>
                            {this.props.authorized === false ?
                                `Siamo spiacenti, non è stata concessa l'autorizzazione per visualizzare questa 
                        pagina.` : `Sistema Informativo Regionale Malattie Infettive`}
                        </strong>
                        <br/>
                        <a href={this.props.authorized === false ? authConfig["url-logout"] : authConfig["url-redirect-home"]}>
                            {this.props.authorized === false ? `Clicca qui per effettuare il login` : `Clicca qui per autenticarti`}
                        </a>
                    </p>
                </div>

            </div>
        );
    }
}
